module.exports = __webpack_public_path__ + "static/media/ignore-icon.fce1e4c4.svg";